/**
 * author: Ananthapadmanabhan V K
 */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "./RiskScoreInput.scss";
import { withTranslation } from "react-i18next";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { Fragment } from "react";
import RiskInputService from "../../../core/service/RiskInputService";
import CompanyService from "../../../core/service/CompanyService";
import Utils from "../../../core/utilities/Utils";
import { RiskReportFrequency, startYear, currentYear } from "../../../core/constants/common";
import RiskConfigService from "../../../core/service/RiskConfigService";
import { FcFinePrint } from "react-icons/fc";

import {
  Button,
  Table,
  Breadcrumb,
  Badge,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { BiGitMerge, BiPencil, BiChevronRight } from "react-icons/bi";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import nodataimg from "../../../images/nodatafound.png";
import { BsXSquare } from "react-icons/bs";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import { RegulationContext } from "../../../App";
const RiskScoreInput = ({ t }) => {
  var lsDat = JSON.parse(localStorage.getItem("authority"));
  const navigate = useNavigate();
  const companyId = lsDat.profile.company.id;
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [regulations, setRegulations] = useState([]);
  const [regulation, setRegulation] = useState([]);
  const [regulationId, setRegulationId] = useState("");
  const riskFrequencyList = RiskReportFrequency({ t });
  const [frequency, setFrequency] = useState("");
  const [supplierchoosed, setSupplierChoosed] = useState("");

  const [riskscorelist, setRiskScoreList] = useState([]);
  const [riskscoreparent, setRiskScoreParent] = useState(null);
  const [riskscoresub, setRiskScoreSub] = useState(null);
  const [issubpage, setIsSubPage] = useState(false);

  const [encoded, setEncoded] = useState(null);
  const [frequencyparam, setFrequencyParam] = useState(null);
  const [supplierid, setSupplierId] = useState(null);

  const [iseditable, setIsEditable] = useState(false);
  const [pathnamearray, setPathNameArray] = useState([]);
  const [weightedmaxscore, setWeightedMaxScore] = useState(null);
  const [weightedscore, setWeightedScore] = useState(null);
  const [overallscore, setOverallScore] = useState(null);
  const { paramObj } = useParams();
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  // const { glbRegulation, setGlbRegulation } = useState([]);
  const [regulationdetails, setRegulationDetails] = useState(null);
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  const [frequencymonth, setFrequencyMonth] = useState('');
  var obj = Utils.decodeBase64(paramObj);
  var decodedObj = JSON.parse(obj);
  const [selecteddat, setSelectedDat] = useState([{
    id: decodedObj.supplier.id,
    legalName: decodedObj.supplier.legalName,
  }])
  let configType = "Supplier";
  useEffect(() => {
    getRegulationDetails(decodedObj.regulation);
    setRegulationId(regulation?.id);
    const month = Utils.getMonthFromFrequency(regulation?.frequency);
    setFrequencyMonth(month);
    setFrequency(regulation?.frequency);
    if (regulation?.id !== '' && regulation?.id != null && regulation?.frequency !== '' && regulation?.frequency != null) {
      // console.log('sds',regulationId,glbRegulation.frequency)
      switch (regulation?.frequency) {
        case 'ANNUAL':
        case 'QUARTERLY':
        case 'HALF_YEARLY': setFrequencyMonth('01');
          break;
        case 'FINANCIAL_YEAR': setFrequencyMonth('04');
          break;
        default:
          break;
      }
      getSuplierData(regulation?.id, regulation?.frequency, annualyear, frequencymonth, decodedObj?.supplier?.id, null);
    }
  }, [regulation?.id]);
  const getRegulationDetails = async (id) => {
    RiskConfigService.getRegulationDetails(id)
      .then((response) => {
        setRegulation(response.data);
      })
      .catch((error) => {
        console.log("err", error);
      });
  }

  const updateFieldChanged = (index) => (e) => {
    const newArr = riskscorelist.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return item;
      }
    });
    setRiskScoreList(newArr);
  };
  const handleSearch = (query) => {
    setIsLoading(true);
    RiskInputService.getSupplier(companyId, query)
      .then((response) => {
        const options = response.data.map((i) => ({
          id: i.companyId,
          legalName: i.legalName,
        }));
        setSelectedDat(null);
        setOptions(options);
        setIsLoading(false);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };
  // useEffect(() => {
  //   getSubscriptions();
  // }, []);
  const getSubscriptions = async (e) => {
    if (companyId) {
      CompanyService.getCompanySubscriptions(companyId)
        .then((response) => {
          var resRegulations = response.data.regulations;
          setRegulations([...resRegulations]);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
          console.log("err", error);
        });
    }
  };
  const filterBy = () => true;
  const handleRegulationChange = (e) => {
    setRegulationId(e.target.value);
  };

  const getSuplierData = (regulationIdDat, frequencyDat, annualYearDat, freqMonth, id, subId) => {
    var string = Utils.generateUrlParamCompanyRegulationWithSupplier(
      companyId,
      regulationIdDat,
      id
    );
    var encodedDat = Utils.encodeBase64(string);

    var frequencyParam = null;
    // if (frequencyDat === "ANNUAL") {
    //   frequencyParam = annualYearDat+"-01-01";
    // } else if (frequencyDat === "FINANCIAL_YEAR") {
    //   frequencyParam = annualYearDat+'-'+finYearStart+'-01';
    // }
    frequencyParam = annualYearDat + '-' + freqMonth + '-01';
    setEncoded(encodedDat);
    setFrequencyParam(frequencyParam);
    setSupplierId(id);
    // console.log('frequencyParam',frequencyParam)
    // return
    RiskInputService.getSupplierData(encodedDat, id, frequencyParam, subId, configType)
      .then((response) => {
        // console.log(response.data);
        setIsEditable(false);
        setRegulationDetails(response.data.regulation);
        setRiskScoreList([...response.data.riskParamData]);
        setWeightedMaxScore(response.data.weightedMaxScore);
        setWeightedScore(response.data.weightedScore);
        var overallScoreData = null;
        if (
          response.data.weightedScore != null &&
          response.data.weightedMaxScore != null
        ) {
          overallScoreData = (
            response.data.weightedScore / response.data.weightedMaxScore
          ).toFixed(2);
        }
        setOverallScore(overallScoreData);
        if (response.data.parentRiskParam != null) {
          // let pathArr = [...pathnamearray];
          // pathArr.push(response.data.parentRiskParam.name);
          // setPathNameArray(pathArr);
          setIsSubPage(true);
          if (response.data.parentRiskParam.parent !== undefined) {
            setRiskScoreParent(response.data.parentRiskParam.parent.id);
          } else {
            setRiskScoreParent(null);
          }
        } else {
          setPathNameArray([]);
          setIsSubPage(false);
          setRiskScoreParent(null);
        }
      })
      .catch((error) => {
        setRiskScoreList([]);
        //ErrorHandlingService.handleError(error.response.status);
        console.log("err", error);
      });
  };

  const submitDataPoint = async (e) => {
    var objBody = {
      dataPoints: [],
    };
    for (let i = 0; i < riskscorelist.length; i++) {
      var body = {
        id: riskscorelist[i].id,
        riskParamId: riskscorelist[i].riskParam.id,
        score: riskscorelist[i].score,
      };
      objBody.dataPoints.push(body);
    }

    // console.log('submit------------', objBody);
    // return
    RiskInputService.saveDataPoint(encoded, supplierid, frequencyparam, objBody)
      .then((response) => {
        //  console.log("response", response);
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsEditable(false);
          getSuplierData(regulationId, frequency, annualyear, frequencymonth, supplierid, riskscoresub);
        }
      })
      .catch((error) => {
        console.log("error", error);
        //ErrorHandlingService.handleError(error.response.status);
        // toast.error(error.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };

  const subBranchRisk = (dat) => {
    if (dat.childrenCount > 0) {
      setRiskScoreSub(dat.id);
      getSuplierData(regulationId, frequency, annualyear, frequencymonth, supplierid, dat.id);
    }
  };

  const goPreviousBranch = (dat) => {
    // let pathArr = [...pathnamearray];
    // pathArr.pop();
    // setPathNameArray(pathArr);
    setRiskScoreSub(riskscoreparent);
    getSuplierData(regulationId, frequency, annualyear, frequencymonth, supplierid, riskscoreparent);
  };

  const riskCategory = (val) => {
    if (val) {
      for (let i = 0; i < regulationdetails.resultConfigs.length; i++) {
        let iterate = regulationdetails.resultConfigs[i];
        if (val >= iterate.minScore && val <= iterate.maxScore) {
          return <p style={{ color: iterate.colorCode }}>{iterate.resultType}</p>;
        }
        if (i === regulationdetails.resultConfigs.length - 1) {
          return <div></div>
        }
      }
    }
  };


  const renderSwitch = () => {
    const options = [];
    for (let i = currentYear; i >= startYear; i--) {
      options.push(<option value={i} key={i}>{i}</option>);
    }
    switch (frequency) {
      case 'ANNUAL':
        return <div> <select
          className="form-select"
          required
          onChange={(e) => {
            setAnnualYear(e.target.value);
            getSuplierData(regulationId, frequency, e.target.value, frequencymonth, decodedObj.supplier.id, null);
          }}
          value={annualyear}>
          {/* <option value="">{t("Select.label")}</option> */}
          {options}
        </select></div>;
      case 'FINANCIAL_YEAR':
        options.length = 0
        for (let i = currentYear; i >= startYear; i--) {
          options.push(<option value={i} key={i}>{i}(APRIL)</option>);
        }
        return <div className="row m-0">
          <div className="col-md-6 px-1">
            <select
              className="form-select"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
                setFrequencyMonth('04');
                getSuplierData(regulationId, frequency, e.target.value, '04', decodedObj.supplier.id, null);
              }}
              value={annualyear}>
              {options}
            </select>
          </div>


          {/* <select
            className="form-select col-md-6"
            required
            onChange={(e) => {
              setFrequencyMonth(e.target.value);
              getSuplierData(regulationId, frequency, annualyear, e.target.value, decodedObj.supplier.id, null);
            }}
            value={frequencymonth}>
            <option value="">{t("Select.label")}</option>
            <option value="01">JAN-DEC</option>
            <option value="04">APR-MAR</option>
          </select> */}

        </div>;
      case 'QUARTERLY':
        return <div className="row m-0">
          <div className="col-md-6 ps-0 pe-2">
            <select
              className="form-select"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
                // getSuplierData(regulationId ,frequency, e.target.value,decodedObj.supplier.id, null);
              }}
              value={annualyear}>
              {/* <option value="">{t("Select.label")}</option> */}
              {options}
            </select>
          </div>
          <div className="col-md-6 px-2">
            <select
              className="form-select"
              required
              onChange={(e) => {
                setFrequencyMonth(e.target.value);
                getSuplierData(regulationId, frequency, annualyear, e.target.value, decodedObj.supplier.id, null);
              }}
              value={frequencymonth}>
              {/* <option value="">{t("Select.label")}</option> */}
              <option value="01">Q1</option>
              <option value="04">Q2</option>
              <option value="07">Q3</option>
              <option value="10">Q4</option>
            </select>
          </div>
        </div>;
      case 'HALF_YEARLY':
        return <div className="row m-0">
          <div className="col-md-6 ps-0 pe-2">
            <select
              className="form-select"
              required
              onChange={(e) => {
                setAnnualYear(e.target.value);
              }}
              value={annualyear}>
              {options}
            </select>
          </div>
          <div className="col-md-6 px-2">
            <select
              className="form-select"
              required
              onChange={(e) => {
                setFrequencyMonth(e.target.value);
                getSuplierData(regulationId, frequency, annualyear, e.target.value, decodedObj.supplier.id, null);
              }}
              value={frequencymonth}>
              <option value="01">JAN-JUN</option>
              <option value="07">JUL-DEC</option>
            </select>
          </div>




        </div>;
      default:
        return '';
    }
  }
  return (
    <div className="RiskScoreInput">
      {/* <div className="List_header">
        <Breadcrumb className="h5">
          <Breadcrumb.Item onClick={() => { navigate(`/company_admin/risk_supplier_list`); }}>{t("Overview.label")}</Breadcrumb.Item>
          <Breadcrumb.Item active> {decodedObj?.supplier.legalName}</Breadcrumb.Item>
        </Breadcrumb>

      </div> */}
      <div className="List_header pb-2">
        <h5 className="MH m-0">{t("Overview.label")}</h5>
      </div>
      <div className="Topics_headeView">
        <ul>
          <li>
            Risk : <b>{glbRegulation.name}</b>
          </li>
          <li>
            Supplier : <b>{decodedObj?.supplier.legalName}</b>
          </li>
        </ul>
        <div className="btn-custom p-1 text-end">
          <button
            className="btn btn-secondary"
            // onClick={() => breadCrumbClick('/topiclist/' + std_id)}
            onClick={() => {
              navigate(`/company_admin/risk_supplier_list`);
            }}
          >
            {t("Back.label")}
          </button>
        </div>
      </div>
      <div className="row m-0">
        {/* {lsDat.roles.includes("SUBSCRIBER_ADMIN") && (
          <div className="col-lg-4  p-2">
            <label className="mb-1">
              {t("Supplier.label")}
            </label>
          
            <AsyncTypeahead
              filterBy={filterBy}
              id="supplier"
              isLoading={isLoading}
              labelKey="legalName"
              minLength={2}
              disabled
              onSearch={handleSearch}
              selected={selecteddat}
              onChange={(selected) => {
                if (selected[0]) {
                  setSelectedDat([{
                    id: selected[0].id,
                    legalName: selected[0].legalName
                  }]);
                  getSuplierData(regulationId, frequency, annualyear, frequencymonth, selected[0].id, null);
                }
              }}
              options={options}
              placeholder={t("Search.label")}
              renderMenuItemChildren={(option, props) => (
                <Fragment>
                  <span>{option.legalName}</span>
                </Fragment>
              )}
            />
          </div>
        )} */}
        {/* <div className="col-lg-4 p-2">
          <label className="mb-1">
            {t("Regulation.label")} <span className="text-red">*</span>
          </label>
          <select className="form-select" onChange={handleRegulationChange}
            value={regulationId}>
            <option>{t("Select.label")}</option>
            {regulations.map((items) => (
              <option value={items.id} key={items.id}>
                {items.name}
              </option>
            ))}
          </select>
        </div> */}
        <div className="col-lg-4  p-2 ps-0">
          <label className="mb-1">
            {t("ReportingPeriod.label")} <span className="text-red">*</span>
          </label>
          {renderSwitch()}
          {/* <select
            className="form-select"
            required
            onChange={(e) => {
              setFrequency(e.target.value);
              getSuplierData(regulationId ,e.target.value,annualyear, decodedObj.supplier.id, null);
            }}
            value={frequency}>
            <option value="">{t("Select.label")}</option>
            {riskFrequencyList.map((items) => (
              <option value={items.value} key={items.value}>
                {items.label}
              </option>
            ))}
          </select> */}
        </div>

      </div>

      <div className="List_Table_01 p-2 ps-0">
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                <th className="ps-3">{t("RiskParameter.label")}</th>
                <th></th>
                <th className="text-center">{t("MaxScore.label")}</th>
                <th className="text-center">
                  <span className="me-2">{t("RiskScore.label")}</span>
                  {riskscorelist &&
                    riskscorelist !== undefined &&
                    riskscorelist.length > 0 && (
                      <span>
                        {!iseditable ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(t("EditRiskScore.label"))}
                          >
                            <span>
                              <BiPencil
                                className="cursor"
                                onClick={() => setIsEditable(!iseditable)}
                              />
                            </span>
                          </OverlayTrigger>
                        ) : (
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(t("CancelEdit.label"))}
                          >
                            <span>
                              <BsXSquare
                                className="cursor"
                                onClick={() => setIsEditable(!iseditable)}
                              ></BsXSquare>{" "}
                            </span>
                          </OverlayTrigger>
                        )}
                      </span>
                    )}
                </th>
                <th className="text-center">{t("RiskScoreIn.label")}</th>
                <th className="text-center">{t("Weightage.label")}</th>
                <th className="text-center">{t("WeightageScore.label")}</th>
              </tr>
            </thead>
            {(riskscorelist === undefined ||
              riskscorelist == null ||
              riskscorelist.length === 0) && (
                <tbody>
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
            {riskscorelist &&
              riskscorelist !== undefined &&
              riskscorelist.length > 0 && (
                <tbody>
                  {riskscorelist?.map((item, index) => (
                    <tr key={index}>
                      <td className="ps-3">{item.riskParam.name}</td>
                      <td>
                        {item.riskParam.childrenCount > 0 ? (
                          <ul className="cursor list-unstyled d-flex align-middle m-0">
                            <li className="px-1">
                              <h6 className="mb-0">
                                {item.riskParam.childrenCount}
                              </h6>
                            </li>
                            <OverlayTrigger
                              placement="top"
                              overlay={Utils.renderTooltip(t("ViewBranch.label"))}
                            >
                              <li
                                className="px-1"
                                onClick={() => subBranchRisk(item.riskParam)}
                              >
                                <BiGitMerge />
                              </li>
                            </OverlayTrigger>
                          </ul>
                        ) : (
                          <span></span>
                        )}
                      </td>
                      <td className="text-center">{item.riskParam.maxScore}</td>
                      <td className="text-center">
                        <div>
                          {iseditable && item.riskParam.childrenCount <= 0 ? (
                            <input
                              value={item.score}
                              name="score"
                              onChange={updateFieldChanged(index)}
                            />
                          ) : (
                            <span>{item.score}</span>
                          )}
                        </div>
                      </td>
                      <td className="text-center">{item.weightedAvgScore}</td>
                      <td className="text-center">
                        {item.riskParam.weightage} %
                      </td>
                      <td className="text-center">{item.weightedScore}</td>
                    </tr>
                  ))}
                  <tr>
                    <td className="text-center" colSpan="4">
                      <div className="save-risk-btn">
                        {issubpage && (
                          <button
                            type="button"
                            onClick={() => {
                              goPreviousBranch();
                            }}
                            className="btn btn-secondary px-4"
                          >
                            {t("Back.label")}
                          </button>
                        )}
                        {iseditable && (
                          <button
                            type="button"
                            onClick={() => {
                              submitDataPoint();
                            }}
                            className="btn btn-primary ms-2 px-4 sbmBtn"
                          >
                            {t("Save.label")}
                          </button>
                        )}
                      </div>
                    </td>
                    <td></td>
                    <td className="text-center">
                      {weightedscore && (
                        <div className="Overall_ScoreBox">
                          <h6 className="m-0">{t("OverAllScore.label")}</h6>
                        </div>
                      )}
                    </td>
                    <td className="text-center">
                      {weightedscore && (
                        <div className="p-2 Overall_ScoreBox_View">
                          <h6 className="m-0 text-primary">{weightedscore}</h6>
                          {/* <p className="m-0 text-orange">
                            {t("Medium.label")}
                          </p> */}
                          {/* <p style={{color:overallriskcolor}}>
                            {riskCategory(weightedscore)}
                          </p> */}
                          {riskCategory(weightedscore)}
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              )}
          </Table>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(RiskScoreInput);
